let baseEndpoint = "https://api.tickets.progroupco.com/newsAndPatchNotes";

module.exports = baseEndpoint;